import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  return (
    <div className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://images.unsplash.com/photo-1576092768241-dec231879fc3?auto=format&fit=crop&q=80&w=2000" 
          alt="Serene tea pouring ritual" 
          className="w-full h-full object-cover object-center scale-105 animate-[pulse_20s_ease-in-out_infinite_alternate]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" aria-hidden="true" />
      </div>
      
      <div className="relative z-10 text-center px-6 max-w-4xl mt-16">
        <motion.p 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="text-moon-white uppercase tracking-[0.4em] text-xs md:text-sm mb-6 md:mb-8 font-medium"
        >
          A Mindful Tradition
        </motion.p>
        
        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
          className="text-5xl md:text-7xl lg:text-8xl font-serif text-moon-white mb-10 leading-[1.1]"
        >
          Serenity in <br className="hidden md:block"/> Every Sip
        </motion.h1>
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
        >
          <a 
            href="#shop" 
            className="inline-block bg-moon-white text-plum-dark px-12 py-4 uppercase tracking-[0.2em] text-xs font-semibold hover:bg-jade hover:text-white transition-all duration-500 hover:shadow-lg hover:-translate-y-1 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-jade focus-visible:ring-offset-2 rounded-sm"
          >
            Explore the Collection
          </a>
        </motion.div>
      </div>

      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-moon-white/70 flex flex-col items-center pointer-events-none"
        aria-hidden="true"
      >
        <span className="uppercase tracking-[0.2em] text-[10px] mb-2">Scroll</span>
        <SafeIcon icon={FiIcons.FiChevronDown} className="w-5 h-5 animate-bounce" />
      </motion.div>
    </div>
  );
};

export default Hero;